module.exports = __webpack_public_path__ + "img/top_safe06.ba999b98.png";